/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { makeStyles } from '@material-ui/core/styles'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { isFunction } from 'lodash'
import React from 'react'
import { WidgetProps } from 'react-jsonschema-form'

import parseValueFromDOM from '../../../lib/parseValueFromDOM'

const useStyles = makeStyles(theme => ({
  input: {
    '&:focus': {
      backgroundColor: theme.palette.common.white,
    },
    fontSize: 20,
    fontWeight: 'bold',
  },
  label: {
    [theme.breakpoints.down('sm')]: {
      '&.MuiInputLabel-shrink': {
        fontSize: '1.125rem',
        transform: 'translate(0, -105%) scale(0.75)',
        width: '125%',
      },
      fontSize: '1rem',
      top: '50%',
      transform: 'translate(0, -50%)',
      width: '90%',
    },
    color: theme.palette.grey['800'],
    fontWeight: 'bold',
  },
}))

const SelectWidget = ({
  schema,
  id,
  options,
  label,
  required,
  disabled,
  readonly,
  value,
  multiple = false,
  autofocus,
  onChange,
  onFocus,
  onBlur,
}: WidgetProps & { multiple?: boolean }) => {
  const enumOptions: { label: string; value: string }[] = Array.isArray(options.enumOptions)
    ? options.enumOptions
    : []
  const enumDisabled: string[] = Array.isArray(options.enumDisabled) ? options.enumDisabled : []
  const emptyValue = multiple ? [] : ''

  const handleChange = ({
    target: { value: targetValue },
  }: React.ChangeEvent<{ name?: string; value: unknown }>) =>
    isFunction(onChange) && onChange(parseValueFromDOM(schema, targetValue))
  const handleBlur = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onBlur) && onBlur(id, parseValueFromDOM(schema, targetValue))
  const handleFocus = ({ target: { value: targetValue } }: React.FocusEvent<HTMLInputElement>) =>
    isFunction(onFocus) && onFocus(id, parseValueFromDOM(schema, targetValue))

  const inputLabel = React.useRef<HTMLLabelElement>(null)
  const [labelWidth, setLabelWidth] = React.useState(0)
  React.useEffect(() => {
    setLabelWidth(inputLabel.current?.offsetWidth ?? 0)
  }, [])

  const classes = useStyles()

  return (
    <FormControl fullWidth margin="normal" required={required}>
      <InputLabel ref={inputLabel} className={classes.label} htmlFor={id}>
        {label || schema.title}
      </InputLabel>

      <Select
        IconComponent={KeyboardArrowDownIcon}
        autoFocus={autofocus}
        classes={{ root: classes.input }}
        color="secondary"
        disabled={disabled || readonly}
        inputProps={{ id }}
        labelWidth={labelWidth}
        multiple={multiple ?? false}
        required={required}
        value={value ?? emptyValue}
        onBlur={handleBlur}
        onChange={handleChange}
        onFocus={handleFocus}
      >
        {enumOptions.map(({ value: enumValue, label: enumLabel }) => {
          const isDisabled = enumDisabled.includes(enumValue)
          return (
            <MenuItem key={enumValue} disabled={isDisabled} value={enumValue}>
              {enumLabel}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default SelectWidget
